module.exports = __webpack_public_path__ + "img/mobile-app.8e500d04.svg";